function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SortDirections } from '@/types/client';
import { Th, Icon, HStack, Text, Box } from '@chakra-ui/react';
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
var _obj;
var IconBySortDirection = (_obj = {}, _define_property(_obj, SortDirections.ASC, /*#__PURE__*/ _jsx(Icon, {
    size: "xs",
    as: FontAwesomeIcon,
    icon: faArrowUp
})), _define_property(_obj, SortDirections.DESC, /*#__PURE__*/ _jsx(Icon, {
    size: "xs",
    as: FontAwesomeIcon,
    icon: faArrowDown
})), _obj);
function TableHeading(_param) {
    var children = _param.children, _param_active = _param.active, active = _param_active === void 0 ? false : _param_active, sort = _param.sort, setSort = _param.setSort, props = _object_without_properties(_param, [
        "children",
        "active",
        "sort",
        "setSort"
    ]);
    var handleSortChange = React.useCallback(function() {
        switch(sort){
            case SortDirections.DESC:
                setSort(SortDirections.ASC);
                break;
            case SortDirections.ASC:
                setSort(null);
                break;
            default:
                setSort(SortDirections.DESC);
                break;
        }
    }, [
        sort,
        setSort
    ]);
    return /*#__PURE__*/ _jsx(Th, _object_spread_props(_object_spread({
        cursor: "pointer",
        userSelect: "none",
        onClick: handleSortChange
    }, props), {
        children: /*#__PURE__*/ _jsxs(HStack, {
            position: "relative",
            width: "fit-content",
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    children: children
                }),
                /*#__PURE__*/ _jsx(Box, {
                    position: "absolute",
                    right: -4,
                    children: active && sort != null ? IconBySortDirection[sort] : null
                })
            ]
        })
    }));
}
export default TableHeading;
